const list = [
    {
        id: 1, label: "Birth Chart",
        url: "/kundali"
    },
    {
        id: 2, label: "Horoscope Matching | kundali Matching | kundali Match for Marriage",
        url: "/kundali-match"
    },
    {
        id: 3, label: "Astrology API Documentation",
        url: "/documentation"
    }
]

const More = () => {
    return (
        <div className="rightlayput">
            <h2 className="section-title">More From Astrology</h2>

            <ul className="listview">
                {list.map(item => (
                    <li key={item.id}>
                        <a href={item.url}>{item.label}</a>
                    </li>
                ))}
            </ul>

        </div>
    );
};

export default More;